import { gql } from '../__generated__';

export const GET_GUIDE_REFERENCED_BY = gql(/* GraphQL */ `
  query GetGuideReferencedBy($id: UUID!) {
    guideReferencedBy(id: $id) {
      guideId
      docId
      docName
      docTitle
      locations {
        headingId
        headingText
        headingNumber
        paragraphId
      }
    }
  }
`);
